import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function LearnSection() {
  const deliverables = [{
    title: 'Mapa de Disparadores del Reflujo',
    desc: 'Descubres qué alimentos, horarios y hábitos te están incendiando por dentro — para dejar de adivinar y sentir control inmediato.'
  }, {
    title: 'Protocolo Anti-Ardor de 72 Horas',
    desc: 'Una secuencia práctica para bajar la irritación digestiva y cortar el ciclo de acidez — para que el pecho deje de sentirse como un horno.'
  }, {
    title: 'Rutina Nocturna Cero Subida',
    desc: 'Aprendes cómo cenar, cuánto esperar y cómo dormir para reducir el reflujo al acostarte — y volver a descansar sin miedo.'
  }, {
    title: 'Sistema de Comidas que No Traicionan',
    desc: 'Una guía simple para comer con menos inflamación y menos presión en el estómago — y sentir alivio sin vivir restringido.'
  }, {
    title: 'Plan de Rescate para Crisis de Agrura',
    desc: 'Qué hacer cuando el reflujo ataca y te desespera — con pasos claros para responder sin pánico.'
  }];
  return <section id="que-recibes" className="py-24 bg-surface" data-id="element-260">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-261">
        <SectionHeader tag="¿Qué desbloquearás?" title={<>
              Todo lo que incluye
              <br data-id="element-263" />
              Reflujo Cero en 72h
            </>} data-id="element-262" />

        <div className="stagger-children grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12" data-id="element-264">
          {deliverables.map((item, idx) => <div key={idx} className="flex items-start gap-4 p-6 bg-secondary border border-white/5 rounded-xl transition-all duration-300 hover:border-accent/30 hover:-translate-y-1" data-id="element-265">
              <CheckCircle2 className="w-6 h-6 text-accent shrink-0 mt-0.5" data-id="element-266" />
              <div data-id="element-267">
                <h3 className="text-base font-bold text-text-light mb-2 leading-tight" data-id="element-268">
                  {item.title}
                </h3>
                <p className="text-sm text-text-muted leading-relaxed" data-id="element-269">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}